import CalendarMonth from './CalendarMonth';

const TypeDatePicker = CalendarMonth;

TypeDatePicker.displayName = 'TypeDatePicker';

export default TypeDatePicker;
